import React from 'react';
import { Popup, PopupProps } from '@progress/kendo-react-popup';

export const CustomDatePopup = (props: PopupProps) => {
  return (
    <Popup
      anchor={props.anchor}
      appendTo={props.appendTo}
      className={props.className}
      id={props.id}
      style={props.style}
      collision={props.collision}
      popupAlign={props.popupAlign}
      anchorAlign={props.anchorAlign}
      offset={props.offset}
      show={props.show}
      animate={false}
    >
      {props.children}
    </Popup>
  );
};
